/**
 * Lo que le falta a Horizon para que la accesibilidad cuadre (22/10/2026,
 * revision de PageSpeed que pidio la clienta).
 *
 * LAS DIAPOSITIVAS ESCONDIDAS NO SE ALCANZAN CON EL TABULADOR. El pase de
 * Horizon (`slideshow-component`: «Vuestros favoritos», las tiras) marca con
 * `aria-hidden="true"` las diapositivas que no se ven, pero deja dentro sus
 * enlaces y botones enfocables: el lector de pantalla no las lee y el
 * tabulador si entra en ellas (Lighthouse, «aria-hidden-focus»). Aqui, cada
 * enfocable de una diapositiva escondida pasa a `tabindex="-1"` y recupera el
 * suyo cuando la diapositiva vuelve a verse. El clic y el arrastre no cambian:
 * `tabindex="-1"` solo saca el elemento del orden del tabulador.
 *
 * Se mira el atributo, no el pase: Horizon lo reescribe al desplazar y al
 * pulsar las flechas, y un `MutationObserver` filtrado a `aria-hidden` no
 * despierta con nada mas. Sin este script todo funciona como antes.
 */
(() => {
  if (window.__nnAccesible) return;
  window.__nnAccesible = true;

  const ENFOCABLES = 'a[href], button, input, select, textarea, [tabindex]';
  const GUARDADO = 'data-nn-tabindex';

  const ajusta = (diapositiva) => {
    const escondida = diapositiva.getAttribute('aria-hidden') === 'true';
    diapositiva.querySelectorAll(ENFOCABLES).forEach((el) => {
      if (escondida) {
        if (el.hasAttribute(GUARDADO)) return;
        el.setAttribute(GUARDADO, el.getAttribute('tabindex') ?? '');
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute(GUARDADO)) {
        const antes = el.getAttribute(GUARDADO);
        if (antes === '') el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', antes);
        el.removeAttribute(GUARDADO);
      }
    });
  };

  const todas = (raiz) => {
    if (raiz.matches?.('slideshow-slide[aria-hidden]')) ajusta(raiz);
    raiz.querySelectorAll?.('slideshow-slide[aria-hidden]').forEach(ajusta);
  };

  const arranca = () => {
    todas(document);
    new MutationObserver((cambios) => {
      for (const c of cambios) {
        if (c.type === 'attributes') {
          if (c.target.localName === 'slideshow-slide') ajusta(c.target);
        } else {
          c.addedNodes.forEach((n) => {
            if (n.nodeType === 1) todas(n);
          });
        }
      }
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca, { once: true });
  else arranca();
})();
